import { render, staticRenderFns } from "./affiliate-review-page-team-members-details.vue?vue&type=template&id=5f1eb896&scoped=true&"
import script from "./affiliate-review-page-team-members-details.vue?vue&type=script&lang=ts&"
export * from "./affiliate-review-page-team-members-details.vue?vue&type=script&lang=ts&"
import style0 from "./affiliate-review-page-team-members-details.vue?vue&type=style&index=0&id=5f1eb896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1eb896",
  null
  
)

export default component.exports